import { render, staticRenderFns } from "./Wise.vue?vue&type=template&id=6a02599c&scoped=true&"
import script from "./Wise.vue?vue&type=script&lang=js&"
export * from "./Wise.vue?vue&type=script&lang=js&"
import style0 from "./Wise.vue?vue&type=style&index=0&id=6a02599c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a02599c",
  null
  
)

export default component.exports